<div class="wrapper wrapper-content mtv-directory-page animated fadeInRight row hide-list-nav-tabs settings-amenities">
    <div class="ibox mainPartPage"
         [class.showDetailedView]="settingsIntegrationsService.showDetailedView"
         [ngStyle]="{width: settingsIntegrationsService.showDetailedView ? 'calc(100% - 390px)' : '100%'}">
        <settings-integrations-apps-list *ngIf="settingsIntegrationsService.isAppsListShow" class="h-100 d-flex flex-column"></settings-integrations-apps-list>
        <settings-integrations-list *ngIf="settingsIntegrationsService.showListView" class="h-100 d-flex flex-column"></settings-integrations-list>
    </div>

    <div class="animated animated-directory slideInRight detailed-view dv-sidebar" style="width: 370px;">
        <settings-integrations-detailed-view *ngIf="settingsIntegrationsService.showDetailedView"></settings-integrations-detailed-view>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-integrations/settings-integrations.component.html